import { withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "two-factor-form" }
const _hoisted_2 = { class: "popup__content" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "popup__controls" }
const _hoisted_5 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup--two-factor",
    title: _ctx.$t('labels.2fa_required'),
    onOnClose: _ctx.cancel2faCode
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FormInputWrapper, {
            errors: _ctx.helper.getErrors('2fa', 'X-2FA-CODE')
          }, {
            default: _withCtx((parentProps) => [
              _withDirectives(_createElementVNode("input", {
                ref: "twoFaInput",
                type: "text",
                onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.confirm2faCode(), ["enter"])),
                "data-maska": "999 999",
                "data-maska-tokens": "9:[0-9]",
                class: _normalizeClass([parentProps.class, "form-control tfa-code"]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.twoFaCode) = $event)),
                placeholder: _ctx.$t('labels.2fa_enter_code')
              }, null, 42, _hoisted_3), [
                [_directive_maska],
                [_vModelText, _ctx.twoFaCode]
              ])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel2faCode && _ctx.cancel2faCode(...args))),
            class: "btn popup__close"
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.confirm2faCode,
            class: "btn btn--accept",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                width: "12",
                height: "10",
                viewBox: "0 0 12 10",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M11.2044 1.6485L4.74285 9.34081C4.67197 9.42524 4.58377 9.49344 4.48423 9.5408C4.3847 9.58817 4.27614 9.61358 4.16592 9.61533H4.15294C4.04512 9.61529 3.93852 9.59259 3.84004 9.54869C3.74156 9.5048 3.65341 9.44069 3.58131 9.36052L0.812078 6.2836C0.741749 6.20901 0.68704 6.12111 0.651168 6.02507C0.615295 5.92903 0.598982 5.82679 0.603186 5.72436C0.607391 5.62193 0.632028 5.52137 0.675651 5.42859C0.719274 5.33581 0.781003 5.2527 0.857208 5.18412C0.933414 5.11554 1.02256 5.06289 1.1194 5.02925C1.21625 4.99562 1.31884 4.98168 1.42115 4.98826C1.52346 4.99484 1.62342 5.02181 1.71515 5.06757C1.80689 5.11334 1.88856 5.17698 1.95535 5.25475L4.13275 7.67399L10.0265 0.659081C10.1587 0.506234 10.3457 0.411551 10.5472 0.395499C10.7486 0.379446 10.9483 0.443313 11.1031 0.573295C11.2578 0.703277 11.3552 0.888932 11.3741 1.09013C11.3931 1.29133 11.3321 1.4919 11.2044 1.6485Z",
                  fill: "#F7F9FC"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.2fa_verify')), 1)
            ]),
            _: 1,
            __: [3]
          }, 8, ["on-click"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}